module.exports = __webpack_public_path__ + "components/flag/static/square/md-c5ec9f199af3272acee89ac7f1fc958e.svg";